import React from 'react';

const BnplContactUs = ({ className }) => {
  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <h1>Contact Us</h1>
      </div>
      <div className={`${className}__divider`} />
      <div className={`${className}__article`}>
        <div className={`${className}__article__text`}>
          Please visit our website at{' '}
          <a href="https://lendistryinteractive.com">https://lendistryinteractive.com</a> or contact
          our dedicated customer service team at 1-888-216-6424, Monday – Friday between the hours
          of 9:00 AM – 8:00 PM Eastern Time.
        </div>
      </div>
    </div>
  );
};

export default BnplContactUs;
